import PagedNavigation from './paged-navigation';

export default PagedNavigation;
